import { useFiltros } from "../lib/filtros";
import { armarFilas, descargarCSV, useAccionesExport, useHayQueExportar } from "../lib/exportar";
import type { Vista } from "../lib/nav";
import { Icono } from "./Base";

/**
 * "Exportar a Excel" de la barra de filtros. Junta todo lo que la vista activa
 * registró (ver src/lib/exportar.tsx) y lo baja en UN archivo, igual que el
 * Radar actual: primero las tarjetas de indicadores y luego cada tabla con el
 * título de su tarjeta. Si la vista no registró nada, se deshabilita en vez de
 * bajar un archivo vacío.
 */
export default function BotonExportar({
  vista, sucursalNombre,
}: {
  vista: Vista;
  sucursalNombre?: string;
}) {
  const acc = useAccionesExport();
  const hayAlgo = useHayQueExportar();
  const { rango } = useFiltros();

  const clic = () => {
    if (!acc) return;
    const filas = armarFilas(acc.recolectar());
    if (!filas.length) return;
    const suc = sucursalNombre ? "-" + sucursalNombre.toLowerCase().replace(/\s+/g, "_") : "";
    descargarCSV(`radar-kex-${vista}${suc}-${rango.desde}_a_${rango.hasta}.csv`, filas);
  };

  return (
    <button
      type="button"
      className="btn-exportar"
      onClick={clic}
      disabled={!hayAlgo}
      title={
        hayAlgo
          ? "Descarga a Excel (CSV) los indicadores y todas las tablas que ves ahora"
          : "Esta vista todavía no tiene nada que exportar"
      }
    >
      <Icono id="i-download" />
      <span className="txt">Exportar a Excel</span>
    </button>
  );
}
